import {Component, inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {CommonModule, CurrencyPipe, ViewportScroller} from '@angular/common';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {switchMap, takeUntil} from 'rxjs/operators';
import {SEOService} from '../../../../core/services/seo.service';
//import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import {Globals} from '../../../../core/services/globals';

import {FooterComponent} from '../../../../shared/components/footer/footer.component';
import {NavigationComponent} from '../../../../shared/components/navigation/navigation.component';
import {NavigationDetailsFullComponent} from '../../../../shared/components/navigation/navigation-details-full.component';
import {ContactFormComponent} from '../../../../shared/components/contact-form/contact-form.component';
import {Subject} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {Data, Listing} from '../../../../core/models/listing';
import {ObservableInput} from 'rxjs/internal/types';

import {PeelHaltonListingsService} from "../../../peelhalton/shared/services/peelhalton-listings.service";
import {TrackingService} from "../../../../core/services/tracking.service";
import {BaseListingDetailsComponent} from "../../../../shared/components/base-listing-details/base-listing-details.component";
import {NavbarBehaviorService} from "../../../../core/services/navbar-behavior.service";
import {BsModalService} from "ngx-bootstrap/modal";
import {TorontoListingsService} from "../../services/toronto-listings.service";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    // ScrollToModule,
    FooterComponent,
    NavigationComponent,
    NavigationDetailsFullComponent,
    ContactFormComponent,
    InfiniteScrollDirective
  ],
  providers: [
    CurrencyPipe,
    NavbarBehaviorService
  ],
  selector: 'toronto-listing-details-full',
  templateUrl: './toronto-listing-details-full.component.html',
  styleUrls: ['../../../../shared/components/listing-details/listing-details-full.component.css'],
})
export class TorontoListingDetailsFullComponent extends BaseListingDetailsComponent implements OnInit, OnDestroy {

  constructor(
    protected override router: Router,
    protected override route: ActivatedRoute,
    protected override http: HttpClient,
    protected override listingsService: TorontoListingsService,
    protected override SEOService: SEOService,
    public override globals: Globals,
    protected override _sanitizer: DomSanitizer,
    protected override scroller: ViewportScroller,
    protected override trackingService: TrackingService,
    protected override breakpointObserver: BreakpointObserver,
    protected override navbarService: NavbarBehaviorService,
    protected override modalService: BsModalService,
    protected override zone: NgZone
  ) {
    super(
      router,
      route,
      http,
      listingsService,
      SEOService,
      globals,
      _sanitizer,
      scroller,
      trackingService,
      breakpointObserver,
      navbarService,
      modalService,
      zone
    )
  }

  ngOnInit() {
    this.initializeBaseListingDetails();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  protected override onListingFetched(listings: Listing): void {
    console.log('onListingFetched: ', listings);
  }
}
